export default class ImpfDbImpfstoff {
    public impfstoffnr: string | null = null;
    public bezeichnung: string | null = null;

    constructor(data?: Partial<ImpfDbImpfstoff>) {
        Object.assign(this, data);
    }
}

export class ImpfDbImpfstoffEdit extends ImpfDbImpfstoff {
    public prevImpfstoffnr?: string | null;

    constructor(data?: Partial<ImpfDbImpfstoffEdit>) {
        super(data);
        Object.assign(this, data);
    }
}
